import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { Stack } from '@chakra-ui/react'
import {
  getPosts,
  setCloseUserPanel,
  setIsBlogFormOpen,
  setOpenBlogForm,
  setPosts,
  setProfileItemId,
  showCurrentChatFriendMarkerCoordinate,
  usersSelectors
} from 'store'
import { motion } from 'framer-motion'
import { UserInformation } from 'components/UserSection/ProfileBlog/UserInformation'
import { PostTypes } from 'components/UserSection/ProfileBlog/PostTypes'
import { ProfileBlogForm } from 'components/UserSection/ProfileBlog/ProfileBlogForm'
import { BlogList } from 'components/UserSection/ProfileBlog/BlogList'
import { isMobile } from 'utils/helpers'

const MotionStack = motion(Stack)

export const ProfileBlog = ({
  selectedUser,
  affinityList
}) => {
  const dispatch = useDispatch()
  const [reload, setReload] = useState(0)
  const [editMode, setEditMode] = useState(false)
  const [editPostData, setEditPostData] = useState({})
  const [finishAnimation, setFinishAnimation] = useState(false)

  const {
    addImagePostsStatus,
    blogParent,
    chosenBlogIndex,
    comments,
    commentsOption,
    deletePostsStatus,
    execAutoArchive,
    getCommentsStatus,
    getPostsStatus,
    openBlogForm,
    postCommentsStatus,
    postPostsStatus,
    postsTypeStatus,
    posts,
    putCommentsStatus,
    putPostsStatus,
    repostThisPostData,
    silentPostId
  } = useSelector(usersSelectors)

  const {
    id,
    full_name,
    profile_picture,
    banner
  } = selectedUser

  const fetchPosts = (lastItemId, lastDateTime) => {
    dispatch(getPosts({
      type: 'profile',
      status: postsTypeStatus,
      id,
      ...(lastItemId === undefined ? {} : { lastItemId }),
      ...(lastDateTime === undefined ? {} : { lastDateTime })
    }))
  }

  const isViewingComment = blogParent.length

  const GoToMarker = (item) => {
    dispatch(setCloseUserPanel(true))
    setTimeout(() => dispatch(setCloseUserPanel(false)), 1050)

    dispatch(setProfileItemId(''))

    setTimeout(() => {
      let coord = {
        coord: item?.coordinates,
        isStatic: true
      }
      dispatch(showCurrentChatFriendMarkerCoordinate(coord))

      sessionStorage.setItem('openProfileAfterAnimation', item?.profile_id)
    }, 1250)
  }

  useEffect(() => {
    dispatch(setPosts([]))
    fetchPosts(undefined, undefined)

    setReload(Math.random())
  }, [postsTypeStatus])

  useEffect(() => {
    if (editMode) {
      dispatch(setOpenBlogForm(editMode))
      setTimeout(() => setFinishAnimation(true), 1000)
    } else {
      setFinishAnimation(false)
    }

    dispatch(setIsBlogFormOpen(editMode))
  }, [editMode])

  useEffect(() => {
    if (Object.keys(repostThisPostData).length) {
      setEditMode(true)
    }
  }, [repostThisPostData])

  return (
    <Stack
      padding="24px 65px"
      backgroundColor="white"
    >
      {reload && (
        <Stack
          direction="column"
          gap="0"
          marginBottom="-25px"
        >
          <Stack
            gap="0"
            display={isViewingComment ? 'none' : 'flex'}
          >
            <MotionStack
              initial={isMobile() && {
                y: 0,
                height: 'auto',
                marginBottom: '15.5px',
                opacity: 1
              }}
              animate={isMobile() && {
                y: editMode ? -100 : 0,
                height: editMode ? 0 : 'auto',
                marginBottom: editMode ? '-17.5px' : '15.5px',
                opacity: editMode ? 0 : 1
              }}
              transition={isMobile() && {
                type: 'tween',
                duration: 1
              }}
              marginBottom={isMobile() ? 'auto' : '15.5px'}
            >
              <UserInformation
                profilePicture={profile_picture}
                fullName={full_name}
                coverPicture={banner}
              />
            </MotionStack>
            <ProfileBlogForm
              blogParent={blogParent}
              selectedUser={selectedUser}
              editPostData={editPostData}
              setEditPostData={setEditPostData}
              editMode={editMode}
              setEditMode={setEditMode}
              postPostsStatus={postPostsStatus}
              putPostsStatus={putPostsStatus}
              addImagePostsStatus={addImagePostsStatus}
              affinityList={affinityList}
              getPostsStatus={getPostsStatus}
              execAutoArchive={execAutoArchive}
              postsTypeStatus={postsTypeStatus}
              openBlogForm={openBlogForm}
              deletePostsStatus={deletePostsStatus}
              repostThisPostData={repostThisPostData}
              GoToMarker={GoToMarker}
              silentPostId={silentPostId}
            />
          </Stack>
          <MotionStack
            initial={isMobile() && {
              y: 0,
              height: editMode ? 0 : 'auto',
              marginBottom: editMode ? 0 : '15.5px'
            }}
            animate={isMobile() && {
              y: editMode && finishAnimation ? 500 : 0,
              height: editMode ? 0 : 'auto',
              marginBottom: editMode ? '-17.5px' : '15.5px'
            }}
            transition={isMobile() && {
              type: 'tween',
              duration: 1
            }}
            display={editMode && isMobile() && finishAnimation ? 'none !important' : 'flex'}
          >
            <Stack
              gap="0"
              display={isViewingComment ? 'none' : 'flex'}
            >
              <PostTypes
                editMode={editMode}
                editPostData={editPostData}
                postsTypeStatus={postsTypeStatus}
              />
            </Stack>
            <BlogList
              blogParent={blogParent}
              chosenBlogIndex={chosenBlogIndex}
              comments={comments}
              commentsOption={commentsOption}
              fetchPosts={fetchPosts}
              finishAnimation={finishAnimation}
              fullName={full_name}
              getCommentsStatus={getCommentsStatus}
              getPostsStatus={getPostsStatus}
              GoToMarker={GoToMarker}
              posts={posts}
              postCommentsStatus={postCommentsStatus}
              postsTypeStatus={postsTypeStatus}
              profileId={id}
              profilePicture={profile_picture}
              putCommentsStatus={putCommentsStatus}
              selectedUser={selectedUser}
              setEditPostData={setEditPostData}
            />
          </MotionStack>
        </Stack>
      )}
    </Stack>
  )
}
